let isCartCleaning = false;

async function validateAndCleanCart() {
  if (isCartCleaning) return;

  try {
    const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const res = await fetch(rootUrl + 'cart.js');
    if (!res.ok) return;

    const cart = await res.json();
    if (!cart || !cart.items || cart.items.length === 0) return;

    const validMasterParentIds = new Set();

    cart.items.forEach(item => {
      const parentId = item.properties && item.properties['_parent_id'];
      const addOnType = item.properties && item.properties['_add_on_type'];

      if (parentId && !addOnType) {
        validMasterParentIds.add(parentId);
      }
    });

    const orphanUpdates = {};
    let orphanFound = false;

    cart.items.forEach(item => {
      const parentId = item.properties && item.properties['_parent_id'];
      const addOnType = item.properties && item.properties['_add_on_type'];

      if (addOnType) {
        if (!parentId || !validMasterParentIds.has(parentId)) {
          orphanUpdates[item.key] = 0;
          orphanFound = true;
        }
      }
    });

    if (orphanFound && Object.keys(orphanUpdates).length > 0) {
      isCartCleaning = true;

      const updateRes = await fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: orphanUpdates })
      });

      if (updateRes.ok) {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }
    }
  } catch (error) {
    console.error('Cart protection error:', error);
  } finally {
    isCartCleaning = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  validateAndCleanCart();
});

document.addEventListener('cart-updated', (e) => {
  validateAndCleanCart();
});

document.addEventListener('theme:cart:refresh', (e) => {
  if (!isCartCleaning) {
    validateAndCleanCart();
  }
});